<template>
   <div id="ltc-loading" style="z-index: 10000;;position: fixed;left:0px;top:0px;width:100vw;height:100vh;background-color: black;overflow-y: hidden;">
    <span class="loader" style="top:30vh"></span>
   </div>
  <!-- <Home msg="LTC Authentication"/> -->
  
  <!-- <div id="app"> -->
    <!-- <router-view></router-view> -->
    <!-- Test!!!!!! -->
    <router-view></router-view>
  <!-- </div> -->
  <!-- <router-view></router-view> -->
</template>

<script>

import './assets/css/loading.css';
import './assets/css/main.css';
import Service from './components/Service';

export default {
  name: 'App',
  mixins: [Service],
  created() {
    // this.$router.push("/");
    setTimeout(() => {
      this.hideLoading();
    }, 400);
  }
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
